import { Component, ViewChild, ElementRef, TemplateRef } from '@angular/core';
import { CMSPortalService } from '../../shared/service/cms-portal.service';
import { Evento } from '../../shared/model/evento.model';

@Component({
  selector: 'app-conteudo-eventos',
  templateUrl: './eventos.component.html',
  styleUrls: ['./eventos.component.css']
})
export class EventosComponent {

  @ViewChild('calendar') calendarEL: ElementRef;
  public eventoSelecionado: Evento;
  public listaEventos: Evento[] = [];

  constructor(private service: CMSPortalService) {
    this.getEventos();
  }

  getEventos() {
    this.service.getEventos().subscribe(res => {
      const conteudo: Array<Evento> = res.conteudo;
      conteudo.sort(function(a, b) { return a.data - b.data; });
      this.listaEventos = conteudo;
      setTimeout(() => {
        this.carregarCalendario();
      }, 100);
    });
  }

  carregarCalendario() {
    let eventos = '';
    for (const evento of this.listaEventos) {
      // tslint:disable-next-line:max-line-length
      // eventos = eventos + `{id: "${evento.id}", title: "${evento.titulo}", description: "${evento.descricao}", datetime: new Date(${evento.data}) },`;
      // tslint:disable-next-line:max-line-length
      eventos = eventos + `{id: "${evento.id}", title: "${evento.titulo}", description: "${evento.descricao}", datetime: new Date(${evento.data}), url: "${evento.url}" },`;
    }
    const js = '<script type="text/javascript">' +
                  '$("#calendar").eCalendar({ events: [' +
                    eventos +
                  ']});' +
               '</script>';
    const fragment = document.createRange().createContextualFragment(js);
    this.calendarEL.nativeElement.appendChild(fragment);
  }

  selecionaEvento(id: number): string {
    for (const evento of this.listaEventos) {
      // tslint:disable-next-line:triple-equals
      if (evento.id == id) {
        this.eventoSelecionado = evento;
      }
    }
    if (this.eventoSelecionado) {
      return this.eventoSelecionado.titulo;
    } else {
      return '';
    }
  }

  getDateFromMilliseconds(time: number): Date {
    return new Date(time);
  }

}
